import { Pipe, PipeTransform } from '@angular/core';
import pluralize from 'pluralize';

@Pipe({
    name: 'pluralize'
})
export class PluralizePipe implements PipeTransform {

    constructor() {
    }

    transform(text: string): any {
        return pluralize(text);
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/pipes/plural.pipe.ts